import logo from "./logo.svg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./App.css";
import { getToken } from "./utils/token";
import { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import Slider from "react-slick";

import { createBrowserHistory } from "history";

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

function App() {
  const [images, setimages] = useState([]);

  useEffect(() => {
    getDarshanData();
  }, []);

  const getDarshanData = async () => {
    const token = await getToken();

    const currentDate = moment(new Date()).format("YYYY-MM-DD");

    if (token) {
      axios
        .get(
          "https://ak7p0muf04.execute-api.ap-south-1.amazonaws.com/api/darshan/v1/dailydarshan/" +
            currentDate,
          {
            headers: {
              "Content-Type": "application/json",
              "X-CLIENT-AUTHORIZATION": token,
            },
          }
        )
        .then((res) => {
          res.data.map((value) => {
            if (value.temple === "WADHWAN") {
              setimages(value.photos);
            }
          });
        });
    }
  };

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: true,
  };

  return (
    <div style={{ width: "100%" }}>
      <Slider {...settings}>
        {images.length > 0 ? (
          images.map((image, index) => (
            <img
              className="slider-image"
              key={index}
              style={{ width: "100%", borderRadius: "10px" }}
              src={image}
              alt=""
            />
          ))
        ) : (
          <div style={{ width: "100%" }}>
            <p style={{ textAlign: "center" }}>દર્શન ટૂંક સમયમાં ઉપલબ્ધ થશે</p>
          </div>
        )}
      </Slider>
    </div>
  );
}

export default App;
